export class UpdatePulumiConfigurationRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonAccountId",
            "baseName": "eonAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "configurationMap",
            "baseName": "configurationMap",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "stackName",
            "baseName": "stackName",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdatePulumiConfigurationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
